import { createContext, useState, useMemo, useEffect } from "react";

export const QueryArticlesContext = createContext();

const PAGE_SIZE = 10;

const getBase = () =>
  process.env.REACT_APP_TEST_MODE === "true"
    ? ""
    : process.env.REACT_APP_S3_BASE_URL || "";

export const QueryArticlesProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortingOption, setSortingOption] = useState("relevance");
  const [page, setPage] = useState(1);
  const [allArticles, setAllArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSearchIndex = async () => {
      setLoading(true);
      try {
        const base = getBase();
        const res = await fetch(`${base}/search-index.json`);
        if (!res.ok) throw new Error("Failed to load search index");
        const text = await res.text();
        const data = JSON.parse(text);
        setAllArticles(data);
        setError("");
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    fetchSearchIndex();
  }, []);

  const filtered = useMemo(() => {
    const term = searchTerm.toLowerCase();
    let result = term
      ? allArticles.filter(
          (a) =>
            a.title?.toLowerCase().includes(term) ||
            a.abstract?.toLowerCase().includes(term)
        )
      : allArticles;

    if (sortingOption === "newest") {
      result = [...result].sort((a, b) => new Date(b.date) - new Date(a.date));
    } else if (sortingOption === "oldest") {
      result = [...result].sort((a, b) => new Date(a.date) - new Date(b.date));
    }

    return result;
  }, [allArticles, searchTerm, sortingOption]);

  const totalArticles = filtered.length;
  const articles = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <QueryArticlesContext.Provider
      value={{
        articles,
        loading,
        error,
        sortingOption,
        setSortingOption,
        searchTerm,
        setSearchTerm,
        page,
        setPage,
        totalArticles,
      }}
    >
      {children}
    </QueryArticlesContext.Provider>
  );
};
